(function () {
  'use strict';

  function pauseAllInlineVideos(root) {
    root.querySelectorAll('[data-inline-video]').forEach(function (v) {
      v.pause();
    });
  }

  function resumeInlineVideos(root) {
    root.querySelectorAll('[data-inline-video]').forEach(function (v) {
      v.play().catch(function () {});
    });
  }

  function initModal(root) {
    var modal = root.querySelector('[data-modal]');
    if (!modal) return;

    var modalVideo = modal.querySelector('[data-modal-video]');
    var activeCard = null;

    function closeModal() {
      if (modalVideo) {
        modalVideo.pause();
        modalVideo.removeAttribute('src');
        modalVideo.querySelectorAll('source').forEach(function (s) {
          s.remove();
        });
      }
      modal.hidden = true;
      document.body.style.overflow = '';
      resumeInlineVideos(root);
      activeCard = null;
    }

    function openModal(card) {
      var kind = card.getAttribute('data-video-kind');
      if (kind !== 'native') return;

      var mp4 = card.getAttribute('data-video-mp4');
      if (!mp4 || !modalVideo) return;

      activeCard = card;

      pauseAllInlineVideos(root);

      modalVideo.hidden = false;
      modalVideo.innerHTML = '';
      var source = document.createElement('source');
      source.src = mp4;
      source.type = 'video/mp4';
      modalVideo.appendChild(source);
      modalVideo.muted = false;
      modalVideo.controls = true;
      modalVideo.play().catch(function () {});

      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    root.addEventListener(
      'click',
      function (e) {
        var openEl = e.target.closest('[data-video-open]');
        if (!openEl || !root.contains(openEl)) return;

        var card = openEl.closest('[data-video-carousel-card]');
        if (!card) return;

        e.preventDefault();
        openModal(card);
      },
      true
    );

    root.addEventListener(
      'keydown',
      function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var openEl = e.target.closest('[data-video-open]');
        if (!openEl || !root.contains(openEl)) return;
        var card = openEl.closest('[data-video-carousel-card]');
        if (!card) return;
        e.preventDefault();
        openModal(card);
      },
      true
    );

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-modal-close]')) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });
  }

  function initMuteToggle(root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mute-toggle]');
      if (!btn || !root.contains(btn)) return;
      e.stopPropagation();
      e.preventDefault();

      var wrap = btn.closest('.product-video-carousel__media-wrap');
      if (!wrap) return;
      var video = wrap.querySelector('[data-inline-video]');
      if (!video) return;

      video.muted = !video.muted;
      btn.setAttribute('aria-pressed', video.muted ? 'true' : 'false');
    });
  }

  function updateCenterSlide(root) {
    if (root.getAttribute('data-center-stage') !== 'true') return;

    var grid = root.querySelector('slider-grid');
    if (!grid) return;

    var slides = grid.querySelectorAll('[slider-grid-slide]');
    if (slides.length < 2) return;

    var gridRect = grid.getBoundingClientRect();
    var centerX = gridRect.left + gridRect.width / 2;
    var best = null;
    var bestDist = Infinity;

    slides.forEach(function (slide) {
      var r = slide.getBoundingClientRect();
      var slideCenter = r.left + r.width / 2;
      var d = Math.abs(slideCenter - centerX);
      if (d < bestDist) {
        bestDist = d;
        best = slide;
      }
    });

    slides.forEach(function (s) {
      s.classList.remove('product-video-carousel__slide--center');
    });
    if (best) {
      best.classList.add('product-video-carousel__slide--center');
    }
  }

  function initCenterStage(root) {
    if (root.getAttribute('data-center-stage') !== 'true') return;

    var grid = root.querySelector('slider-grid');
    if (!grid) return;

    var track = grid.querySelector('[slider-grid-track]');
    var debounced = function () {
      window.requestAnimationFrame(function () {
        updateCenterSlide(root);
      });
    };

    var obs = new MutationObserver(debounced);
    if (track) {
      obs.observe(track, { attributes: true, attributeFilter: ['style'] });
    }

    window.addEventListener('resize', debounced);
    grid.addEventListener('scroll', debounced, { passive: true });

    grid.querySelectorAll('.carousel-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTimeout(debounced, 400);
      });
    });

    debounced();
  }

  function initSection(root) {
    initModal(root);
    initMuteToggle(root);
    initCenterStage(root);
  }

  document.querySelectorAll('[data-product-video-carousel]').forEach(initSection);
})();
